import { civilDaysBetween } from '@/utils/Common'

export const MATCH_DAY_WINDOW_BEFORE = 4

export const MATCH_DAY_WINDOW_AFTER = 10

export const matchDayLabel = (date, competenceDates = []) => {
    if (!competenceDates.length || !date) return null
    if (competenceDates.includes(date)) return 'MD'
    const next = competenceDates.find(d => d > date)
    const prev = [...competenceDates].reverse().find(d => d < date)
    const diff = (a, b) => civilDaysBetween(b, a)
    if (next && diff(next, date) <= MATCH_DAY_WINDOW_BEFORE) return `MD-${diff(next, date)}`
    if (prev && diff(date, prev) <= MATCH_DAY_WINDOW_AFTER) return `MD+${diff(date, prev)}`
    return null
}
